import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const VinegarPage = () => {
  const options = [
    {
      volume: '2L',
      tag: 'Econômico',
      tagColor: 'bg-amber-700',
      description: 'Embalagem econômica, ideal para uso diário na cozinha. Perfeito para famílias que adoram temperar com sabor e qualidade.',
      image: 'https://public.readdy.ai/ai/img_res/aa435206-6a7e-45e3-8a42-7b8577b213e2.png',
      highlight: 'Maior rendimento',
    },
    {
      volume: '740ml',
      tag: 'Prático',
      tagColor: 'bg-[#6B1E1E]',
      description: 'Tamanho prático e ideal para experimentar ou presentear. Fácil de guardar e manusear no dia a dia.',
      image: 'https://public.readdy.ai/ai/img_res/3700675c-6c3c-4806-a9af-46485b94875c.png',
      highlight: 'Ótimo para presentear',
    },
  ];

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/fd7de0f0438d9fd5afc24ad52321030d.jpg"
              alt="Salada fresca com ingredientes para temperar com vinagre"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/30"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
            <span className="inline-block bg-white/15 text-white text-xs font-semibold px-3 py-1 rounded-full tracking-widest uppercase mb-5 backdrop-blur-sm">
              Produção Artesanal
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-5 max-w-2xl leading-tight">
              Vinagre Tinto Colonial
            </h1>
            <p className="text-white/80 text-sm md:text-base max-w-md leading-relaxed mb-8">
              Fermentado pelo método tradicional com uvas tintas selecionadas. Acidez natural perfeita para saladas, marinadas e conservas artesanais.
            </p>
            <a
              href="https://wa.me/5500000000000"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-amber-700 text-white px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-amber-800 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i>
              Pedir pelo WhatsApp
            </a>
          </div>
        </section>

        {/* Options */}
        <section className="py-20 md:py-28 bg-[#faf7f5]">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center mb-14">
              <span className="text-amber-700 text-xs font-semibold tracking-widest uppercase">Disponível em</span>
              <h2 className="mt-3 text-3xl md:text-4xl font-bold text-[#1a0a0a]">Escolha o Seu Tamanho</h2>
              <p className="mt-3 text-[#7a5555] text-sm max-w-md mx-auto">
                Mesmo sabor artesanal e qualidade superior, em dois tamanhos para atender sua necessidade.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              {options.map((opt) => (
                <div key={opt.volume} className="group bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
                  {/* Image with salad background */}
                  <div className="relative h-72 overflow-hidden">
                    <img
                      src={`https://readdy.ai/api/search-image?query=fresh-salad-ingredients-green-lettuce-sliced-tomatoes-arugula-basil-rustic-wooden-table-mediterranean-food-styling-natural-light-$%7Bopt.volume%7D-vinegar-bottle&width=600&height=500&seq=vinegar-opt-${opt.volume}&orientation=landscape`}
                      alt={`Vinagre ${opt.volume} com salada`}
                      className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                    <span className={`absolute top-4 left-4 ${opt.tagColor} text-white text-xs font-semibold px-3 py-1 rounded-full`}>
                      {opt.tag}
                    </span>
                    {/* Bottle overlay */}
                    <div className="absolute bottom-0 right-4 flex flex-col items-center justify-end" style={{ height: '285px' }}>
                      <img
                        src={opt.image}
                        alt={`Vinagre Colonial ${opt.volume}`}
                        className="w-auto object-contain object-bottom"
                        style={{ height: '265px', filter: 'drop-shadow(0 12px 28px rgba(0,0,0,0.6))' }}
                      />
                      <div className="w-12 h-2 rounded-full bg-black/40 blur-sm -mt-1"></div>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-[#1a0a0a] font-bold text-2xl">{opt.volume}</h3>
                      <span className="text-xs bg-[#f5ece8] text-amber-700 px-3 py-1 rounded-full font-medium">{opt.highlight}</span>
                    </div>
                    <p className="text-[#7a5555] text-sm leading-relaxed mb-5">{opt.description}</p>
                    <a
                      href="https://wa.me/5500000000000"
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="flex items-center justify-center gap-2 w-full bg-[#6B1E1E] text-white py-3.5 rounded-xl font-semibold text-sm hover:bg-[#8B2E2E] transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-whatsapp-line"></i>
                      Pedir Vinagre {opt.volume}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Uses Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <div className="w-full lg:w-1/2">
                <div className="relative rounded-2xl overflow-hidden" style={{ height: 420 }}>
                  <img
                    src="https://readdy.ai/api/search-image?query=colorful-fresh-salad-bowl-green-arugula-lettuce-sliced-tomatoes-basil-leaves-olive-oil-dressing-rustic-ceramic-bowl-wooden-table-mediterranean-healthy-food-close-up-vibrant-colors&width=700&height=700&seq=vinegar-uses&orientation=squarish"
                    alt="Salada com vinagre colonial"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <span className="inline-block bg-[#f5ece8] text-amber-700 text-xs font-semibold px-3 py-1 rounded-full tracking-widest uppercase mb-5">
                  Versatilidade
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-[#1a0a0a] mb-6 leading-snug">
                  Para Mil e Uma Receitas
                </h2>
                <div className="space-y-4">
                  {[
                    { icon: 'ri-leaf-line', title: 'Saladas Frescas', desc: 'Combine com azeite e ervas para um tempero perfeito em alface, rúcula e tomate.' },
                    { icon: 'ri-fire-line', title: 'Marinadas', desc: 'Ideal para marinar carnes, dando sabor e maciez incomparáveis aos seus assados.' },
                    { icon: 'ri-store-2-line', title: 'Conservas Caseiras', desc: 'Conserve legumes e vegetais com sabor e qualidade artesanal.' },
                    { icon: 'ri-cup-line', title: 'Molhos Especiais', desc: 'Base perfeita para molhos vinagrete e temperos gourmet caseiros.' },
                  ].map((item) => (
                    <div key={item.title} className="flex gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#f5ece8] text-amber-700 flex-shrink-0">
                        <i className={`${item.icon} text-lg`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-[#1a0a0a] text-sm mb-1">{item.title}</h4>
                        <p className="text-[#7a5555] text-xs leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-amber-700">
          <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Leve o Sabor Colonial para sua Mesa</h2>
            <p className="text-white/80 text-sm mb-8">Disponível em 2L e 740ml. Faça seu pedido agora!</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="https://wa.me/5500000000000" target="_blank" rel="nofollow noreferrer" className="flex items-center gap-2 bg-white text-amber-700 px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-whatsapp-line"></i> Pedir pelo WhatsApp
              </a>
              <Link to="/#contato" className="flex items-center gap-2 bg-white/15 text-white px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-mail-line"></i> Enviar Mensagem
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default VinegarPage;
